// extracted by mini-css-extract-plugin
module.exports = {"card":"AnswerCard_card__362ti","flex":"AnswerCard_flex__3AVus","active":"AnswerCard_active__rC7k5","inactive":"AnswerCard_inactive__3mtza"};